import {ValueObject} from '@s-ui/domain'

export class ContactModelSellerResponseValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.leadId
   */
}
